import React from 'react';

const ShopList = () => {
    // Get the selectedProducts from local storage
    const selectedProducts = JSON.parse(localStorage.getItem('selectedProducts')) || [];
  
    return (
      <div>
        <h3>Shop List</h3>
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col">Product Name</th>
              <th scope="col">Month</th>
            </tr>
          </thead>
          <tbody>
            {selectedProducts.map((product, index) => (
              <tr key={index}>
                <td>{product.name}</td>
                <td>{product.month}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  
  

export default ShopList;
